import TimeMe from "timeme.js"

window.TimeMe = TimeMe
